import { UserDTO } from './UserDTO';
import { Utils } from '../utils/utils';
import { KeyDriversDTO } from './KeyDriversDTO';
import { Serializable } from './Serializable';

export class CommentDTO extends Serializable {

    id: string;
    feedbackBy: UserDTO;
    isAnonymous: boolean;
    titleFeedback: string;
    feedback: string;
    response: string;
    responseBy: UserDTO;
    responseOn: string;
    questionName: string;
    questionID: string;
    keyDriver: KeyDriversDTO;
    score: number;

    constructor() {
        super();
    }

    get dateResponse() {
        let dateResponse = "";
        let date = new Date(this.responseOn);
        dateResponse = Utils.dateToString(date).replace(/-/g, "/");
        return dateResponse;
    }

}